export const transformListToMap = (list) => {
  return list.reduce((acc, cur) => {
    acc[cur.value] = cur;
    return acc;
  }, {});
};

export const transformListToConst = (list) => {
  return list.reduce((acc, cur) => {
    acc[cur.key] = cur.value;
    return acc;
  }, {});
};
